
import axios from "axios";

const API_URL = "/api/partners";
const COMPANY_API_URL = "/api/company-details";
const SUBSCRIPTION_PURCHASE_API_URL =
  "/api/subscription-purchases";

// =====================================================
// GET ALL PARTNERS
// GET /api/partners/all
// =====================================================
export const getAllPartners = () => {
  return axios.get(`${API_URL}/all`);
};

// =====================================================
// SAVE PARTNER
// POST /api/partners/save
// =====================================================
export const savePartner = (data) => {
  return axios.post(`${API_URL}/save`, {
    companyName: data.companyName,
    companyType: data.companyType,
    website: data.website,

    gst: data.gst || null,
    pan: data.pan || null,

    name: data.name,
    designation: data.designation,

    mobile: data.mobile,
    email: data.email || null,

    state: data.state,
    city: data.city,
    address: data.address,
    pincode: data.pincode,

    remark: data.remark || null,
  });
};

// =====================================================
// DELETE PARTNER
// DELETE /api/partners/{id}
// =====================================================
export const deletePartner = (id) => {
  return axios.delete(`${API_URL}/${id}`);
};

// =====================================================
// UPDATE PARTNER STATUS
// PUT /api/partners/{id}/status
// =====================================================
export const updatePartnerStatus = (id, status) => {
  if (!id) {
    throw new Error("Partner ID is required");
  }

  if (!status || !status.trim()) {
    throw new Error("Partner status is required");
  }

  return axios.put(`${API_URL}/${id}/status`, {
    status: status.trim().toUpperCase(),
  });
};

// =====================================================
// GET COMPANY DETAILS BY PARTNER ID
// GET /api/company-details/partner/{partnerId}
// =====================================================
export const getCompanyDetailsByPartnerId = (partnerId) => {
  if (!partnerId) {
    throw new Error("Partner ID is required");
  }

  return axios.get(`${COMPANY_API_URL}/partner/${partnerId}`);
};

// =====================================================
// UPDATE COMPANY VERIFICATION STATUS
// PUT /api/company-details/partner/{partnerId}/verification
//
// Body:
// {
//   "status": "APPROVED",
//   "verificationStatus": "APPROVED",
//   "remark": "Documents verified"
// }
// =====================================================

export const updateCompanyVerificationStatus = (partnerId, data) =>
    axios.put(
        `${COMPANY_API_URL}/partner/${partnerId}/verification`,
        {
            status: data.status,
            remark: data.remark || null,
        }
    );

// =====================================================
// GET SUBSCRIPTION DETAILS BY PARTNER ID
// GET /api/subscriptions/partner/{partnerId}
// =====================================================
export const getSubscriptionDetailsByPartnerId = (partnerId) => {
  return axios.get(
    `/api/subscriptions/partner/${partnerId}`
  );
};

export const getActiveFeatureUsage = (userId, userType, featureCode) => {
  return axios.get("/api/subscription-usage/active", {
    params: {
      userId,
      userType,
      featureCode,
    },
  });
};


// =====================================================
// GET PARTNER SUBSCRIPTIONS
// GET /api/subscription-purchases/user/{partnerId}
// =====================================================
// =====================================================
// GET SUBSCRIPTION PURCHASES BY PARTNER ID
// GET /api/subscription-purchases/partner/{partnerId}
// =====================================================
export const getPartnerSubscriptions = (partnerId) => {
  if (!partnerId) {
    throw new Error("Partner ID is required");
  }

  return axios.get(
    `${SUBSCRIPTION_PURCHASE_API_URL}/partner/${partnerId}`
  );
};
// =====================================================
// GET ACTIVE PARTNER SUBSCRIPTION
// GET /api/subscription-purchases/user/{partnerId}/active
// =====================================================
export const getActivePartnerSubscription = (partnerId) => {
  return axios.get(
    `${SUBSCRIPTION_PURCHASE_API_URL}/user/${partnerId}/active`
  );
};
